import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import '@angular/localize/init';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideCharts(withDefaultRegisterables()),
    provideRouter(routes, withEnabledBlockingInitialNavigation(),   // <-- replaces initialNavigation
),
    provideAnimations(),
    provideHttpClient(withInterceptors([ /* your interceptors here */ ])),
    provideClientHydration(withEventReplay()),

    // Use importProvidersFrom to import external modules like ToastrModule
    importProvidersFrom(
      BrowserAnimationsModule,
      CommonModule,
      NgxChartsModule,
      BsDatepickerModule.forRoot(),
      ModalModule.forRoot(),
      ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
        closeButton: true,
        progressBar: true,
        progressAnimation: 'increasing',
      })
    )
  ]
};
